module.exports = __webpack_public_path__ + "plat/static/img/login_logo_overseas.4586fbd5.png";